(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2785],{

/***/ 14144:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, module], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else { var mod; }
})(this, function (exports, module) {
  'use strict';

  var defaultOptions = {
    timeout: 5000,
    jsonpCallback: 'callback',
    jsonpCallbackFunction: null
  };

  function generateCallbackFunction() {
    return 'jsonp_' + Date.now() + '_' + Math.ceil(Math.random() * 100000);
  }

  function clearFunction(functionName) {
    // IE8 throws an exception when you try to delete a property on window
    // http://stackoverflow.com/a/1824228/751089
    try {
      delete window[functionName];
    } catch (e) {
      window[functionName] = undefined;
    }
  }

  function removeScript(scriptId) {
    var script = document.getElementById(scriptId);
    if (script) {
      document.getElementsByTagName('head')[0].removeChild(script);
    }
  }

  function fetchJsonp(_url) {
    var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

    // to avoid param reassign
    var url = _url;
    var timeout = options.timeout || defaultOptions.timeout;
    var jsonpCallback = options.jsonpCallback || defaultOptions.jsonpCallback;

    var timeoutId = undefined;

    return new Promise(function (resolve, reject) {
      var callbackFunction = options.jsonpCallbackFunction || generateCallbackFunction();
      var scriptId = jsonpCallback + '_' + callbackFunction;

      window[callbackFunction] = function (response) {
        resolve({
          ok: true,
          // keep consistent with fetch API
          json: function json() {
            return Promise.resolve(response);
          }
        });

        if (timeoutId) clearTimeout(timeoutId);

        removeScript(scriptId);

        clearFunction(callbackFunction);
      };

      // Check if the user set their own params, and if not add a ? to start a list of params
      url += url.indexOf('?') === -1 ? '?' : '&';

      var jsonpScript = document.createElement('script');
      jsonpScript.setAttribute('src', '' + url + jsonpCallback + '=' + callbackFunction);
      if (options.charset) {
        jsonpScript.setAttribute('charset', options.charset);
      }
      if (options.nonce) {
        jsonpScript.setAttribute('nonce', options.nonce);
      }
      if (options.referrerPolicy) {
        jsonpScript.setAttribute('referrerPolicy', options.referrerPolicy);
      }
      jsonpScript.id = scriptId;
      document.getElementsByTagName('head')[0].appendChild(jsonpScript);

      timeoutId = setTimeout(function () {
        reject(new Error('JSONP request to ' + _url + ' timed out'));

        clearFunction(callbackFunction);
        removeScript(scriptId);
        window[callbackFunction] = function () {
          clearFunction(callbackFunction);
        };
      }, timeout);

      // Caught if got 404/500
      jsonpScript.onerror = function () {
        reject(new Error('JSONP request to ' + _url + ' failed'));

        clearFunction(callbackFunction);
        removeScript(scriptId);
        if (timeoutId) clearTimeout(timeoutId);
      };
    });
  }

  // export as global function
  /*
  let local;
  if (typeof global !== 'undefined') {
    local = global;
  } else if (typeof self !== 'undefined') {
    local = self;
  } else {
    try {
      local = Function('return this')();
    } catch (e) {
      throw new Error('polyfill failed because global object is unavailable in this environment');
    }
  }
  local.fetchJsonp = fetchJsonp;
  */

  module.exports = fetchJsonp;
});

/***/ }),

/***/ 62896:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BC": function() { return /* binding */ media; },
/* harmony export */   "FG": function() { return /* binding */ RPR_TOKEN; },
/* harmony export */   "m3": function() { return /* binding */ schemaJson; },
/* harmony export */   "nT": function() { return /* binding */ BOOKING_LINK; },
/* harmony export */   "tn": function() { return /* binding */ RPR_WIDGET_URL; },
/* harmony export */   "uW": function() { return /* binding */ RPR_CBCODE; }
/* harmony export */ });
var RPR_TOKEN = 'EE6A11F4-EC71-46F7-82BB-EFF0B38B4D15';
var RPR_CBCODE = 'btsrichrhomes';
var RPR_WIDGET_URL = 'https://www.narrpr.com/widgets/avm-widget/widget.ashx/html';
var BOOKING_LINK = 'https://links.richr.com/schedule-time';
var media = {
  lockIcon: '/static/images/home-valuation/lock-icon.svg',
  reportBlur: '/static/images/home-valuation/report-blur.jpg',
  valueBlur: '/static/images/home-valuation/value-blur.jpg',
  richrLogo: '/static/logo-richr-new.svg',
  thankYouImage: '/static/images/home-valuation/thank-you.svg'
};
var schemaJson = {
  '@context': 'http://schema.org',
  '@type': 'WebPage',
  name: 'Free Home Valuation Tool',
  description: "Get a free estimate of your home's value with Richr's home valuation tool. Our proprietary algorithm analyzes data from recent home sales in your area to provide you with an accurate valuation.",
  publisher: {
    '@type': 'Organization',
    name: 'Richr',
    logo: {
      '@type': 'ImageObject',
      url: 'https://richr.com/logo.png',
      width: '200',
      height: '200'
    }
  },
  breadcrumb: {
    '@type': 'BreadcrumbList',
    itemListElement: [{
      '@type': 'ListItem',
      position: 1,
      name: 'Home',
      item: 'https://richr.com/'
    }, {
      '@type': 'ListItem',
      position: 2,
      name: 'Free Home Valuation Tool',
      item: 'https://richr.com/free-home-valuation'
    }]
  }
};

/***/ }),

/***/ 58120:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ googleAutocomplete; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-places-autocomplete/dist/index.js
var dist = __webpack_require__(48837);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
// EXTERNAL MODULE: ./components/google-places/useGooglePlaces.ts
var useGooglePlaces = __webpack_require__(97652);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(68777);
// EXTERNAL MODULE: ./styles/breakpoints.ts
var breakpoints = __webpack_require__(20881);
;// CONCATENATED MODULE: ./components/home-valuation/valuation-form/googleAutocomplete.styled.ts


var GoogleAutocompleteWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "googleAutocompletestyled__GoogleAutocompleteWrapper",
  componentId: "sc-x73tdx-0"
})(["width:100%;max-width:840px;background-color:", ";height:auto;position:relative;z-index:1;display:flex;align-items:center;", " .places{&-container{flex-grow:1;display:flex;align-items:center;gap:24px;.autocomplete{flex-grow:1;height:100%;&-input{font-weight:", ";width:100%;max-width:840px;background-color:", ";margin:0.5rem 0;padding:0.5rem 0.625rem 0.5625rem;height:43px;font-size:16px;border:1px solid ", ";&:hover{border-color:hsl(0,0%,70%);}&:focus{border:1px solid ", ";}&.invalid{border:1px solid ", ";}&::placeholder{color:", ";}@media ", "{font-size:12px;line-height:24px;}}&-dropdown{box-shadow:0 5px 20px 0 rgb(0 0 0 / 9%);padding-left:8px;padding-right:8px;position:absolute;z-index:999;top:calc(100% - 1px);width:100%;border-bottom-left-radius:6px;border-bottom-right-radius:6px;background-color:", ";font-weight:", ";> div{padding:8px 0;margin-bottom:8px;cursor:pointer;&:hover{background-color:", "1A;}}}&-text-field-error{font-weight:", ";font-size:12px;line-height:20px;color:", ";}}> button{width:182px;height:64px;padding:20px 30px;border-radius:60px;> p{color:", ";}@media ", "{width:56px;height:56px;border-radius:50%;padding:16px;> p{display:none;}}}}}&.variant-1{height:110px;border-radius:40px;@media ", "{height:60px;padding:2px;padding-left:30px;border-radius:60px;}.places-container{> button{background-color:", ";height:94px;border-radius:32px;> p{color:", ";}@media ", "{height:56px;}}}.places-note{width:max-content;left:50%;transform:translateX(-50%);background-color:", ";padding:12px 28px;@media ", "{width:207px;padding:8px 16px;}}}"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.white;
}, function (_ref2) {
  var hasLabel = _ref2.hasLabel;
  return hasLabel && (0,styled_components_browser_esm/* css */.iv)(["display:flex;flex-direction:column;align-items:flex-start;.outlined-input-label{margin:0;}.places-container{width:100%;}"]);
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.typography.fontWeights.light;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.white;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.grayPallet22;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.bluePallet2;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.red;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.colors.grayPallet13;
}, breakpoints/* device.tablet */.U.tablet, function (_ref9) {
  var theme = _ref9.theme;
  return theme.colors.white;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.typography.fontWeights.light;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.colors.grayPallet1;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.typography.fontWeights.medium;
}, function (_ref13) {
  var theme = _ref13.theme;
  return theme.colors.red;
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.colors.bluePallet1;
}, breakpoints/* device.tablet */.U.tablet, breakpoints/* device.laptop */.U.laptop, function (_ref15) {
  var theme = _ref15.theme;
  return theme.colors.bluePallet1;
}, function (_ref16) {
  var theme = _ref16.theme;
  return theme.colors.white;
}, breakpoints/* device.laptop */.U.laptop, function (_ref17) {
  var theme = _ref17.theme;
  return theme.colors.greenPallet2;
}, breakpoints/* device.mobile */.U.mobile);
// EXTERNAL MODULE: ./components/common/text-field/index.tsx
var text_field = __webpack_require__(80367);
// EXTERNAL MODULE: ./components/common/typography/index.tsx
var typography = __webpack_require__(9769);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/home-valuation/valuation-form/googleAutocomplete.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }













function GoogleAutocomplete(_ref) {
  var forBuy = _ref.forBuy,
      placeholder = _ref.placeholder,
      mode = _ref.mode,
      setValue = _ref.setValue,
      error = _ref.error,
      clearErrors = _ref.clearErrors,
      name = _ref.name,
      setGoogleData = _ref.setGoogleData,
      trigger = _ref.trigger,
      label = _ref.label,
      defaultValue = _ref.defaultValue;

  var _useState = (0,react.useState)(false),
      isTouched = _useState[0],
      setIsTouched = _useState[1];

  var _useGooglePlace = (0,useGooglePlaces/* useGooglePlace */.K)(),
      input = _useGooglePlace.input,
      hanldeChange = _useGooglePlace.hanldeChange,
      hanldeSelect = _useGooglePlace.hanldeSelect,
      selOptions = _useGooglePlace.selOptions,
      buyOptions = _useGooglePlace.buyOptions,
      googleData = _useGooglePlace.googleData,
      setGoogleHookData = _useGooglePlace.setGoogleData;

  (0,react.useEffect)(function () {
    setGoogleHookData({
      full: input
    });
    setValue('address', input);

    if (!(0,lodash.isNil)(input)) {
      clearErrors('address');
    }
  }, [clearErrors, input, setGoogleHookData, setValue]);
  (0,react.useEffect)(function () {
    if (!(0,lodash.isEmpty)(defaultValue) && !(0,lodash.isNil)(defaultValue)) {
      setGoogleHookData({
        full: defaultValue
      });
      hanldeChange(defaultValue);
      setValue('address', defaultValue);
    }
  }, [defaultValue, hanldeChange, setGoogleHookData, setValue]);
  (0,react.useEffect)(function () {
    if (isTouched) {
      trigger('address');
    }
  }, [isTouched, trigger]);
  (0,react.useEffect)(function () {
    if (!(0,lodash.isNil)(googleData) && (0,lodash.isFunction)(setGoogleData)) {
      setGoogleData(googleData);
    }
  }, [googleData, setGoogleData]);

  function handleInputBlur(placesAutocompleteBlurHandler) {
    return function onBlur() {
      placesAutocompleteBlurHandler();
      setIsTouched(true);
    };
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(GoogleAutocompleteWrapper, {
    className: classnames_default()('places', {
      'variant-1': mode === 'variant-1'
    }),
    hasLabel: Boolean(label),
    children: [label && /*#__PURE__*/(0,jsx_runtime.jsx)(text_field/* TextFieldLabel */.pU, {
      "data-testid": "text-field-label",
      className: "outlined-input-label",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("label", {
        htmlFor: name,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(typography/* default */.Z, {
          fontWeight: "medium",
          children: label
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "places-container",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(dist/* default */.ZP, {
        value: input,
        onChange: hanldeChange,
        onSelect: hanldeSelect,
        searchOptions: forBuy ? buyOptions.current : selOptions.current,
        children: function children(_ref2) {
          var getInputProps = _ref2.getInputProps,
              suggestions = _ref2.suggestions,
              getSuggestionItemProps = _ref2.getSuggestionItemProps,
              loading = _ref2.loading;
          return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "autocomplete",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("input", _objectSpread(_objectSpread({
              placeholder: "".concat(placeholder || "Address"),
              className: classnames_default()({
                invalid: Boolean(error),
                'autocomplete-input': true
              }),
              id: name
            }, getInputProps()), {}, {
              onBlur: handleInputBlur(getInputProps().onBlur)
            })), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "autocomplete-text-field-error",
              children: (error === null || error === void 0 ? void 0 : error.message) && /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                children: error.message
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "autocomplete-dropdown",
              children: [loading && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                children: "Loading..."
              }), (0,lodash.map)(suggestions, function (suggestion, idx) {
                return /*#__PURE__*/(0,react.createElement)("div", _objectSpread(_objectSpread({}, getSuggestionItemProps(suggestion)), {}, {
                  key: idx
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  children: suggestion.description
                }));
              })]
            })]
          });
        }
      })
    })]
  });
}

/* harmony default export */ var googleAutocomplete = (/*#__PURE__*/(0,react.memo)(GoogleAutocomplete));

/***/ }),

/***/ 18577:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useMedia; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_use__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(98504);


function useMedia() {
  var _useWindowSize = (0,react_use__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(),
      width = _useWindowSize.width;

  var isMobile = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    return width >= 0 && width <= 480;
  }, [width]);
  var isTablet = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    return width >= 481 && width <= 768;
  }, [width]);
  var isSmallLaptop = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    return width >= 769 && width <= 1024;
  }, [width]);
  var isLaptop = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    return width >= 1025 && width <= 1280;
  }, [width]);
  var isLargeLaptop = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    return width >= 1281;
  }, [width]);
  var isBelowTablet = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    return width < 481;
  }, [width]);
  var isBelowSmallLaptop = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    return width < 769;
  }, [width]);
  var isBelowLaptop = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    return width < 1025;
  }, [width]);
  var isBelowLargeLaptop = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    return width < 1281;
  }, [width]);
  var isAboveMobile = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    return width > 480;
  }, [width]);
  var isAboveTablet = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    return width > 768;
  }, [width]);
  var isAboveSmallLaptop = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    return width > 1024;
  }, [width]);
  var isAboveLaptop = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    return width > 1280;
  }, [width]);
  return {
    isMobile: isMobile,
    isTablet: isTablet,
    isSmallLaptop: isSmallLaptop,
    isLaptop: isLaptop,
    isLargeLaptop: isLargeLaptop,
    isBelowTablet: isBelowTablet,
    isBelowSmallLaptop: isBelowSmallLaptop,
    isBelowLaptop: isBelowLaptop,
    isBelowLargeLaptop: isBelowLargeLaptop,
    isAboveMobile: isAboveMobile,
    isAboveTablet: isAboveTablet,
    isAboveSmallLaptop: isAboveSmallLaptop,
    isAboveLaptop: isAboveLaptop
  };
}

/***/ }),

/***/ 79853:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ free_home_valuation; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(27812);
// EXTERNAL MODULE: ./node_modules/@hookform/resolvers/yup/dist/yup.mjs + 1 modules
var yup = __webpack_require__(47533);
// EXTERNAL MODULE: ./node_modules/fetch-jsonp/build/fetch-jsonp.js
var fetch_jsonp = __webpack_require__(14144);
var fetch_jsonp_default = /*#__PURE__*/__webpack_require__.n(fetch_jsonp);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(44012);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./components/homepage-footer/index.tsx + 4 modules
var homepage_footer = __webpack_require__(27316);
// EXTERNAL MODULE: ./components/homepage-header/index.tsx + 4 modules
var homepage_header = __webpack_require__(34804);
// EXTERNAL MODULE: ./hooks/useMedia.ts
var useMedia = __webpack_require__(18577);
// EXTERNAL MODULE: ./hooks/useTriggerFunnelyticsEvent/index.ts
var useTriggerFunnelyticsEvent = __webpack_require__(91974);
// EXTERNAL MODULE: ./hooks/useTriggerFunnelyticsEvent/constants.ts
var constants = __webpack_require__(16300);
// EXTERNAL MODULE: ./store/slices/homeValuation/thunks.ts
var thunks = __webpack_require__(31346);
// EXTERNAL MODULE: ./utils/validations.ts + 1 modules
var validations = __webpack_require__(87023);
// EXTERNAL MODULE: ./components/home-valuation/constants.ts
var home_valuation_constants = __webpack_require__(62896);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/index.js + 1 modules
var lib = __webpack_require__(54490);
;// CONCATENATED MODULE: ./components/home-valuation/messages.ts

var scope = 'app.components.HomeValuation';
/* harmony default export */ var messages = ((0,lib/* defineMessages */.vU)({
  header: {
    id: "".concat(scope, ".header"),
    defaultMessage: 'What{rsquo}s your home worth?'
  },
  headerOneForMobile: {
    id: "".concat(scope, ".headerOneForMobile"),
    defaultMessage: 'See what{rsquo}s your home worth'
  },
  headerTwoForMobile: {
    id: "".concat(scope, ".headerTwoForMobile"),
    defaultMessage: 'You{rsquo}re Just One Step Away From Your Free Home Valuation'
  },
  submitButton: {
    id: "".concat(scope, ".submitButton"),
    defaultMessage: 'Get My Home Value Report'
  },
  disclaimer: {
    id: "".concat(scope, ".disclaimer"),
    defaultMessage: 'By submitting your information, you consent and agree that Richr and its affiliates may use automated technology, including pre-recorded messages, cell phones, and texts, and email to contact you at the number and email address you provided. This includes if your number is currently on any Do Not Call Lists. Consent is not required to make a purchase. Message and data rates may apply. You also agree to Our Terms of Service.'
  },
  formHeader: {
    id: "".concat(scope, ".formHeader"),
    defaultMessage: 'Don{rsquo}t sell for less. Complete the form and get your [free] home value estimate instantly'
  },
  viewMoreDetails: {
    id: "".concat(scope, ".viewMoreDetails"),
    defaultMessage: 'View more details'
  },
  backCTA: {
    id: "".concat(scope, ".backCTA"),
    defaultMessage: 'Back'
  },
  editCTA: {
    id: "".concat(scope, ".editCTA"),
    defaultMessage: 'Edit'
  },
  estimationHeading: {
    id: "".concat(scope, ".estimationHeading"),
    defaultMessage: 'Your estimated home value is'
  },
  estimationNote: {
    id: "".concat(scope, ".estimationNote"),
    defaultMessage: 'This is our estimate of your home value and is intended to be used for illustrative purposes only and does not represent a confirmation of actual home value.'
  },
  tenXNote: {
    id: "".concat(scope, ".tenXNote"),
    defaultMessage: 'Make 10X more money when you sell your home, Sell your home for only a 1% fee, and earn 4.58% interest on your home sale proceeds'
  },
  startListingCTA: {
    id: "".concat(scope, ".startListingCTA"),
    defaultMessage: 'Start listing now'
  },
  chatBotNote: {
    id: "".concat(scope, ".chatBotNote"),
    defaultMessage: 'Having questions? Talk to our chatbot to get answers to you most pressing questions, or to access our assistance.'
  },
  showMoreCTA: {
    id: "".concat(scope, ".showMoreCTA"),
    defaultMessage: 'Show More'
  },
  showLessCTA: {
    id: "".concat(scope, ".showLessCTA"),
    defaultMessage: 'Show Less'
  },
  chartHeading: {
    id: "".concat(scope, ".chartHeading"),
    defaultMessage: 'Estimated Value Over Time'
  },
  cmaHeading: {
    id: "".concat(scope, ".cmaHeading"),
    defaultMessage: 'Want A Comparative Market Analysis? '
  },
  cmaDescription: {
    id: "".concat(scope, ".cmaDescription"),
    defaultMessage: 'Get a free market analysis with detailed information of home sales similar to your home to find out how you can get the most out of your home sale.'
  },
  cmaCTA: {
    id: "".concat(scope, ".cmaCTA"),
    defaultMessage: 'Get a free CMA report'
  },
  addressErrorTitle: {
    id: "".concat(scope, ".addressErrorTitle"),
    defaultMessage: 'Oops!'
  },
  addressErrorSubtitle: {
    id: "".concat(scope, ".addressErrorSubtitle"),
    defaultMessage: 'Seems like we couldn’t get an estimate for this address.'
  },
  addressErrorDescription: {
    id: "".concat(scope, ".addressErrorDescription"),
    defaultMessage: 'Fear not! You can request a callback and an expert from our team will assist you as soon as possible. In the meantime you can interact with our chatbot to assist you with your questions.'
  },
  addressErrorCTA: {
    id: "".concat(scope, ".addressErrorCTA"),
    defaultMessage: 'Get a callback'
  },
  requestSent: {
    id: "".concat(scope, ".requestSent"),
    defaultMessage: 'Request Sent'
  }
}));
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(68777);
// EXTERNAL MODULE: ./styles/breakpoints.ts
var breakpoints = __webpack_require__(20881);
;// CONCATENATED MODULE: ./components/home-valuation/styles.ts


var ValuationWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styles__ValuationWrapper",
  componentId: "sc-1o3ltwp-0"
})(["min-height:100vh;display:flex;flex-direction:column;background:url('/static/images/home-valuation/hero.webp');background-size:cover;background-repeat:no-repeat;color:#fff;padding-top:95px;@media ", "{padding-top:64px;}@media ", "{background:url('/static/images/home-valuation/hero-mobile.webp');background-size:cover;background-repeat:no-repeat;}", ""], breakpoints/* device.tablet */.U.tablet, breakpoints/* device.mobile */.U.mobile, function (_ref) {
  var isSectionTwo = _ref.isSectionTwo;
  return isSectionTwo && (0,styled_components_browser_esm/* css */.iv)(["background:none !important;"]);
});
var Heading = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
  displayName: "styles__Heading",
  componentId: "sc-1o3ltwp-1"
})(["font-family:", ";font-size:43px;margin:40px 0 20px;padding:0 70px;@media ", "{padding:0 30px;}@media ", "{font-size:", ";text-align:center;padding:0 20px;}"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.typography.fontFamily.Inter;
}, breakpoints/* device.laptop */.U.laptop, breakpoints/* device.tablet */.U.tablet, function (_ref3) {
  var isMobileStepTwo = _ref3.isMobileStepTwo;
  return isMobileStepTwo ? '25px' : '40px';
});
var FormAndWidgetWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styles__FormAndWidgetWrapper",
  componentId: "sc-1o3ltwp-2"
})(["display:flex;align-items:center;justify-content:space-between;gap:30px;padding:0 130px 20px 70px;@media ", "{padding:0 30px 20px;}@media ", "{flex-direction:column;padding:0 20px 20px;}"], breakpoints/* device.laptop */.U.laptop, breakpoints/* device.tablet */.U.tablet);
var FormWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styles__FormWrapper",
  componentId: "sc-1o3ltwp-3"
})(["width:466px;@media ", "{width:100%;margin-top:20px;}"], breakpoints/* device.tablet */.U.tablet);
var WidgetSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styles__WidgetSection",
  componentId: "sc-1o3ltwp-4"
})(["display:flex;justify-content:center;white-space:initial;position:relative;min-height:", ";@media ", "{width:100%;align-self:center;}"], function (_ref4) {
  var hasWidgetLoaded = _ref4.hasWidgetLoaded;
  return hasWidgetLoaded ? '460px' : '650px';
}, breakpoints/* device.tablet */.U.tablet);
var WidgetOverlayImage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styles__WidgetOverlayImage",
  componentId: "sc-1o3ltwp-5"
})(["position:absolute;z-index:2;top:50%;left:50%;transform:translate(-50%,-50%);"]);
/* harmony default export */ var styles = ({
  ValuationWrapper: ValuationWrapper,
  Heading: Heading,
  FormAndWidgetWrapper: FormAndWidgetWrapper,
  FormWrapper: FormWrapper,
  WidgetSection: WidgetSection,
  WidgetOverlayImage: WidgetOverlayImage
});
// EXTERNAL MODULE: ./components/common/text-field/index.tsx
var text_field = __webpack_require__(80367);
// EXTERNAL MODULE: ./components/common/text-field-phone/index.tsx
var text_field_phone = __webpack_require__(73480);
// EXTERNAL MODULE: ./hooks/useWindow.ts
var useWindow = __webpack_require__(1284);
// EXTERNAL MODULE: ./components/home-valuation/valuation-form/googleAutocomplete.tsx + 1 modules
var googleAutocomplete = __webpack_require__(58120);
;// CONCATENATED MODULE: ./components/home-valuation/valuation-form/styles.ts


var ValuationFormWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styles__ValuationFormWrapper",
  componentId: "sc-1tfjpq8-0"
})(["width:100%;height:100%;color:", ";background-color:", ";padding:30px;& > p{font-weight:", ";font-size:1rem;}input{font-weight:", ";width:100%;max-width:840px;background-color:", ";padding:0.5rem 0.625rem 0.5625rem;height:43px;font-size:15px;border:1px solid ", ";}@media ", "{& > p{font-size:1rem;}}@media ", "{input,button{font-size:16px !important;}}@media ", "{padding:20px 30px 40px !important;& > p{text-align:center;}}"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.black;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.white;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.typography.fontWeights.regular;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.typography.fontWeights.light;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.white;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.grayPallet12;
}, breakpoints/* device.laptop */.U.laptop, breakpoints/* device.smallLaptop */.U.smallLaptop, breakpoints/* device.tablet */.U.tablet);
var ValuationFormWrapperMobile = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styles__ValuationFormWrapperMobile",
  componentId: "sc-1tfjpq8-1"
})(["display:none;.autocomplete-input{margin:0 !important;}.autocomplete-text-field-error{display:none;}.autocomplete-dropdown{color:black;}@media ", "{display:block;}"], breakpoints/* device.tablet */.U.tablet);
var AddressInputWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styles__AddressInputWrapper",
  componentId: "sc-1tfjpq8-2"
})(["@media ", "{display:none;}"], breakpoints/* device.tablet */.U.tablet);
var AddressInputWrapperMobile = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styles__AddressInputWrapperMobile",
  componentId: "sc-1tfjpq8-3"
})(["padding:40px 20px 60px;input{font-size:16px !important;font-family:", " !important;font-weight:400 !important;border:1px solid ", " !important;padding:15px 18px !important;&::placeholder{color:", " !important;opacity:1;}}"], function (_ref7) {
  var theme = _ref7.theme;
  return theme.typography.fontFamily.walsheimProRegular;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.colors.grayPallet23;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.colors.grayPallet24;
});
var FormHeader = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  displayName: "styles__FormHeader",
  componentId: "sc-1tfjpq8-4"
})(["font-family:", ";font-size:17px;font-weight:500;@media ", "{font-family:", ";font-size:14px !important;padding:0 20px;text-align:center;}"], function (_ref10) {
  var theme = _ref10.theme;
  return theme.typography.fontFamily.Inter;
}, breakpoints/* device.tablet */.U.tablet, function (_ref11) {
  var theme = _ref11.theme;
  return theme.typography.fontFamily.walsheimProMedium;
});
var SpinKeyframe = (0,styled_components_browser_esm/* keyframes */.F4)(["0%{transform:rotate(0deg);}100%{transform:rotate(360deg);}"]);
var SubmitButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
  displayName: "styles__SubmitButton",
  componentId: "sc-1tfjpq8-5"
})(["background:#00d4a1;color:", ";font-size:17px;font-weight:", ";width:100%;cursor:pointer;display:flex;justify-content:center;padding:", ";&:disabled{cursor:not-allowed;opacity:0.7;}.btn-ring:after{content:'';display:block;width:25px;height:25px;margin:2px;border-radius:50%;border:3px solid ", ";border-color:", " transparent;animation:", " 1.2s linear infinite;@media ", "{width:20px;height:20px;}}@media ", "{font-family:", ";padding:", ";}"], function (_ref12) {
  var theme = _ref12.theme;
  return theme.colors.white;
}, function (_ref13) {
  var theme = _ref13.theme;
  return theme.typography.fontWeights.medium;
}, function (_ref14) {
  var isLoading = _ref14.isLoading;
  return isLoading ? '12.5px' : '20px';
}, function (_ref15) {
  var theme = _ref15.theme;
  return theme.colors.white;
}, function (_ref16) {
  var theme = _ref16.theme;
  return theme.colors.white;
}, SpinKeyframe, breakpoints/* device.tablet */.U.tablet, breakpoints/* device.tablet */.U.tablet, function (_ref17) {
  var theme = _ref17.theme;
  return theme.typography.fontFamily.walsheimProMedium;
}, function (_ref18) {
  var isLoading = _ref18.isLoading;
  return isLoading ? '12px' : '18px';
});
var NameInput = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styles__NameInput",
  componentId: "sc-1tfjpq8-6"
})(["display:flex;align-items:center;justify-content:space-between;gap:30px;div{flex:1;margin-top:0 !important;}"]);
var HomeValuationForm = styled_components_browser_esm/* default.form.withConfig */.ZP.form.withConfig({
  displayName: "styles__HomeValuationForm",
  componentId: "sc-1tfjpq8-7"
})(["display:flex;flex-direction:column;gap:25px;margin-top:20px;div{margin:0 !important;}input{font-size:17px !important;font-weight:400 !important;height:59px !important;border:1px solid ", " !important;padding:19px 20px !important;margin:0 !important;}input::placeholder{color:", ";}@media ", "{margin-top:25px;input{font-family:", ";font-size:16px !important;font-weight:400;padding:15px 18px !important;&::placeholder{color:", ";}}}"], function (_ref19) {
  var theme = _ref19.theme;
  return theme.colors.grayPallet22;
}, function (_ref20) {
  var theme = _ref20.theme;
  return theme.colors.grayPallet13;
}, breakpoints/* device.tablet */.U.tablet, function (_ref21) {
  var theme = _ref21.theme;
  return theme.typography.fontFamily.walsheimProRegular;
}, function (_ref22) {
  var theme = _ref22.theme;
  return theme.colors.grayPallet25;
});
var PriceDetailsWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styles__PriceDetailsWrapper",
  componentId: "sc-1tfjpq8-8"
})(["text-align:center;& .value-image{margin-bottom:20px;position:relative;}& .priceWrapper{color:", ";h1{margin:10px;font-family:ui-sans-serif,system-ui,-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,'Helvetica Neue',Arial,'Noto Sans',sans-serif,'Apple Color Emoji','Segoe UI Emoji','Segoe UI Symbol','Noto Color Emoji';font-size:35px;}p{font-weight:", ";text-decoration:underline;cursor:pointer;-webkit-tap-highlight-color:rgba(255,255,255,0);margin:15px 0px 20px;color:", ";font-size:15px;}}"], function (_ref23) {
  var theme = _ref23.theme;
  return theme.colors.greenPallet3;
}, function (_ref24) {
  var theme = _ref24.theme;
  return theme.typography.fontWeights.regular;
}, function (_ref25) {
  var theme = _ref25.theme;
  return theme.colors.grayPallet14;
});
var Disclaimer = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  displayName: "styles__Disclaimer",
  componentId: "sc-1tfjpq8-9"
})(["color:", ";font-weight:", ";font-size:14px;font-weight:400;line-height:18px;@media ", "{display:none;}"], function (_ref26) {
  var theme = _ref26.theme;
  return theme.colors.grayPallet15;
}, function (_ref27) {
  var theme = _ref27.theme;
  return theme.typography.fontWeights.light;
}, breakpoints/* device.tablet */.U.tablet);
var BackCTA = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
  displayName: "styles__BackCTA",
  componentId: "sc-1tfjpq8-10"
})(["display:none;font-family:", ";font-size:16px;color:", ";background-color:transparent;border:1px solid ", ";text-align:center;padding:16px;@media ", "{display:block;}"], function (_ref28) {
  var theme = _ref28.theme;
  return theme.typography.fontFamily.walsheimProMedium;
}, function (_ref29) {
  var theme = _ref29.theme;
  return theme.colors.blackPallet6;
}, function (_ref30) {
  var theme = _ref30.theme;
  return theme.colors.blackPallet6;
}, breakpoints/* device.tablet */.U.tablet);
var SelectedAddress = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  displayName: "styles__SelectedAddress",
  componentId: "sc-1tfjpq8-11"
})(["display:none;font-family:", ";font-size:16px;text-align:center;color:", ";margin-top:25px;@media ", "{display:block;}"], function (_ref31) {
  var theme = _ref31.theme;
  return theme.typography.fontFamily.walsheimProRegular;
}, function (_ref32) {
  var theme = _ref32.theme;
  return theme.colors.greenPallet5;
}, breakpoints/* device.tablet */.U.tablet);
;// CONCATENATED MODULE: ./components/home-valuation/valuation-form/thankYou.styled.tsx


var ThankYouWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "thankYoustyled__ThankYouWrapper",
  componentId: "sc-qrucux-0"
})(["width:100%;height:100%;display:flex;justify-content:center;align-items:center;flex-direction:column;text-align:center;@media ", "{margin-top:70px;}"], breakpoints/* device.tablet */.U.tablet);
var ThankYouImageWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "thankYoustyled__ThankYouImageWrapper",
  componentId: "sc-qrucux-1"
})(["margin-bottom:20px;"]);
var ThankYouDescription = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "thankYoustyled__ThankYouDescription",
  componentId: "sc-qrucux-2"
})(["margin-top:20px;h1{font-size:40px;font-weight:", ";color:", ";}p{font-weight:", ";font-size:17px;margin-top:15px;}@media ", "{h1{font-size:35px;}p{font-size:16px;}}p > a{color:", ";text-decoration:underline;}"], function (_ref) {
  var theme = _ref.theme;
  return theme.typography.fontWeights.bold;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.green;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.typography.fontWeights.regular;
}, breakpoints/* device.tablet */.U.tablet, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.green;
});
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/home-valuation/valuation-form/thankYouMessage.tsx







function ThankYouMessage() {
  var _useWindow = (0,useWindow/* useWindow */.z)(),
      width = _useWindow.w;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(ThankYouWrapper, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ThankYouImageWrapper, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
        src: home_valuation_constants/* media.thankYouImage */.BC.thankYouImage,
        width: width > 768 ? 174 : 146,
        height: width > 768 ? 174 : 146,
        alt: "Thank you"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(ThankYouDescription, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
        children: "Thank You!"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Someone from Richr will be in touch soon. In the meantime, you can", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          href: home_valuation_constants/* BOOKING_LINK */.nT,
          children: "book time with Richr here."
        })]
      })]
    })]
  });
}

/* harmony default export */ var thankYouMessage = (ThankYouMessage);
;// CONCATENATED MODULE: ./components/home-valuation/valuation-form/valuationPriceMobile.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }













function ValuationPrice(_ref) {
  var price = _ref.price,
      scrollToWidget = _ref.scrollToWidget,
      showDetailButton = _ref.showDetailButton;

  var _useState = (0,react.useState)(''),
      priceCounter = _useState[0],
      setPriceCounter = _useState[1];

  var displayPriceRef = (0,react.useRef)(null);
  (0,react.useEffect)(function () {
    if (price) {
      animateValue({
        start: 0,
        end: (0,lodash.toNumber)(price.replace(/,/g, '').slice(1)),
        duration: 2000,
        updatePrice: updatePrice
      });
    }
  }, [price]);

  function updatePrice(updatedPrice) {
    setPriceCounter(updatedPrice);
  }

  return price ? /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "priceWrapper",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
      ref: displayPriceRef,
      children: priceCounter
    }), showDetailButton ? /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      onClick: scrollToWidget,
      "aria-hidden": true,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, _objectSpread({}, messages.viewMoreDetails))
    }) : null]
  }) : /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "value-image",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(styles.WidgetOverlayImage, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
        src: home_valuation_constants/* media.lockIcon */.BC.lockIcon,
        width: 31,
        height: 31,
        alt: ""
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
      src: home_valuation_constants/* media.valueBlur */.BC.valueBlur,
      width: 250,
      height: 80,
      alt: "price-preview"
    })]
  });
}

function ValuationPriceMobile(_ref2) {
  var price = _ref2.price,
      scrollToWidget = _ref2.scrollToWidget,
      showDetailButton = _ref2.showDetailButton;

  var _useWindow = (0,useWindow/* useWindow */.z)(),
      width = _useWindow.w;

  return /*#__PURE__*/(0,jsx_runtime.jsx)(PriceDetailsWrapper, {
    children: width <= 768 ? /*#__PURE__*/(0,jsx_runtime.jsx)(ValuationPrice, {
      price: price,
      scrollToWidget: scrollToWidget,
      showDetailButton: showDetailButton
    }) : null
  });
}

function animateValue(_ref3) {
  var start = _ref3.start,
      end = _ref3.end,
      duration = _ref3.duration,
      updatePrice = _ref3.updatePrice;
  var startTimestamp = null;

  function step(timestamp) {
    if (!startTimestamp) startTimestamp = timestamp;
    var progress = Math.min((timestamp - startTimestamp) / duration, 1);
    var price = Math.floor(progress * (end - start) + start);
    updatePrice("$".concat(price.toLocaleString('en-US')));

    if (progress < 1) {
      window.requestAnimationFrame(step);
    }
  }

  window.requestAnimationFrame(step);
}

/* harmony default export */ var valuationPriceMobile = (ValuationPriceMobile);
;// CONCATENATED MODULE: ./components/home-valuation/valuation-form/index.tsx


function valuation_form_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function valuation_form_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? valuation_form_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : valuation_form_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }















function ValuationForm(_ref) {
  var onSubmit = _ref.onSubmit,
      widgetError = _ref.widgetError,
      price = _ref.price,
      loading = _ref.loading,
      hasWidgetLoaded = _ref.hasWidgetLoaded,
      setGoogleData = _ref.setGoogleData,
      scrollToWidget = _ref.scrollToWidget,
      homeValuationForm = _ref.homeValuationForm,
      address = _ref.address,
      onBack = _ref.onBack;

  var _useState = (0,react.useState)(false),
      showDetailButton = _useState[0],
      setShowDetailButton = _useState[1];

  var _useWindow = (0,useWindow/* useWindow */.z)(),
      width = _useWindow.w;

  var register = homeValuationForm.register,
      handleSubmit = homeValuationForm.handleSubmit,
      errors = homeValuationForm.formState.errors,
      control = homeValuationForm.control,
      setValue = homeValuationForm.setValue,
      clearErrors = homeValuationForm.clearErrors,
      setError = homeValuationForm.setError,
      trigger = homeValuationForm.trigger,
      getValues = homeValuationForm.getValues;
  var timeoutDuration = width > 768 ? 0 : 2000;
  (0,react.useEffect)(function () {
    if (widgetError) {
      setError('address', {
        type: 'custom',
        message: 'We could not understand the property address you entered. Please make sure you enter a full property address.'
      });
    }
  }, [widgetError, setError]);
  (0,react.useEffect)(function () {
    var timer;

    if (price) {
      timer = setTimeout(function () {
        setShowDetailButton(true);
      }, timeoutDuration);
    } else {
      setShowDetailButton(false);
    }

    return function () {
      return clearTimeout(timer);
    };
  }, [price, timeoutDuration]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(ValuationFormWrapper, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(valuationPriceMobile, {
      price: price,
      scrollToWidget: scrollToWidget,
      showDetailButton: showDetailButton
    }), hasWidgetLoaded && showDetailButton ? /*#__PURE__*/(0,jsx_runtime.jsx)(thankYouMessage, {}) : /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FormHeader, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, valuation_form_objectSpread(valuation_form_objectSpread({}, messages.formHeader), {}, {
          values: {
            rsquo: /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
              children: "\u2019"
            })
          }
        }))
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(SelectedAddress, {
        children: address
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(HomeValuationForm, {
        onSubmit: handleSubmit(onSubmit),
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(AddressInputWrapper, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(googleAutocomplete/* default */.Z, {
            setValue: setValue,
            clearErrors: clearErrors,
            name: "address",
            error: errors.address,
            setGoogleData: setGoogleData,
            trigger: trigger,
            defaultValue: getValues('address')
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(NameInput, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(text_field/* default */.ZP, {
            type: "text",
            name: "first_name",
            register: register,
            placeholder: "First Name",
            error: errors.first_name
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(text_field/* default */.ZP, {
            type: "text",
            name: "last_name",
            register: register,
            placeholder: "Last Name",
            error: errors.last_name
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(text_field/* default */.ZP, {
          type: "email",
          name: "email",
          register: register,
          placeholder: "Email",
          error: errors.email
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(text_field_phone/* default */.Z, {
          name: "phone_number",
          control: control,
          error: errors.phone_number
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(SubmitButton, {
          type: "submit",
          isLoading: loading,
          disabled: loading,
          children: loading ? /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: "btn-ring"
          }) : /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, valuation_form_objectSpread({}, messages.submitButton))
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Disclaimer, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, valuation_form_objectSpread({}, messages.disclaimer))
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BackCTA, {
          type: "button",
          onClick: onBack,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, valuation_form_objectSpread({}, messages.backCTA))
        })]
      })]
    })]
  });
}

/* harmony default export */ var valuation_form = (ValuationForm);
;// CONCATENATED MODULE: ./components/home-valuation/valuation-form/valuationFormMobile.tsx


function valuationFormMobile_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function valuationFormMobile_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? valuationFormMobile_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : valuationFormMobile_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }








function ValuationFormMobile(_ref) {
  var setGoogleData = _ref.setGoogleData,
      homeValuationForm = _ref.homeValuationForm;
  var errors = homeValuationForm.formState.errors,
      setValue = homeValuationForm.setValue,
      clearErrors = homeValuationForm.clearErrors,
      trigger = homeValuationForm.trigger,
      getValues = homeValuationForm.getValues;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(ValuationFormWrapperMobile, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FormHeader, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, valuationFormMobile_objectSpread(valuationFormMobile_objectSpread({}, messages.formHeader), {}, {
        values: {
          rsquo: /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: "\u2019"
          })
        }
      }))
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(AddressInputWrapperMobile, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(googleAutocomplete/* default */.Z, {
        setValue: setValue,
        clearErrors: clearErrors,
        placeholder: "Enter your address",
        name: "address",
        error: errors.address,
        setGoogleData: setGoogleData,
        trigger: trigger,
        defaultValue: getValues('address')
      })
    })]
  });
}
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(16835);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react-use/esm/useToggle.js
var useToggle = __webpack_require__(89211);
;// CONCATENATED MODULE: ./containers/free-home-valuation/slice/selector.ts
var requestCallbackSelector = function requestCallbackSelector(state) {
  return state.freeHomeValuation.requestCallback;
};
// EXTERNAL MODULE: ./containers/free-home-valuation/slice/thunks.ts
var slice_thunks = __webpack_require__(17922);
// EXTERNAL MODULE: ./hooks/useRedux.ts
var useRedux = __webpack_require__(22152);
;// CONCATENATED MODULE: ./store/slices/homeValuation/selector.ts
var homeValuationSelector = function homeValuationSelector(state) {
  return state.homeValuationSlice;
};
// EXTERNAL MODULE: ./utils/scroll.ts
var utils_scroll = __webpack_require__(82142);
// EXTERNAL MODULE: ./components/common/typography/index.tsx
var typography = __webpack_require__(9769);
;// CONCATENATED MODULE: ./store/slices/cma/selector.ts
var cmaSelector = function cmaSelector(state) {
  return state.cma;
};
// EXTERNAL MODULE: ./store/slices/cma/thunks.ts
var cma_thunks = __webpack_require__(82963);
;// CONCATENATED MODULE: ./components/home-valuation/valuation-result/styles.ts


var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styles__Wrapper",
  componentId: "sc-l5ldl0-0"
})(["font-family:", ";color:", ";display:flex;flex-direction:column;.get-callback-cta{gap:10px;&:disabled{display:flex;align-items:center;}img.tick-icon{filter:brightness(0) invert(1);}}@media ", "{.get-callback-cta{margin-bottom:96px;}}"], function (_ref) {
  var theme = _ref.theme;
  return theme.typography.fontFamily.Inter;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.blackPallet6;
}, breakpoints/* device.tablet */.U.tablet);
var ResultWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styles__ResultWrapper",
  componentId: "sc-l5ldl0-1"
})(["min-height:calc(100vh - 95px);width:100%;display:flex;align-items:center;justify-content:space-between;gap:30px;padding:0 182px 20px 70px;@media ", "{padding:0 30px 20px;}@media ", "{flex-direction:column;align-items:flex-start;gap:40px;padding:20px;}"], breakpoints/* device.laptop */.U.laptop, breakpoints/* device.tablet */.U.tablet);
var LeftWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styles__LeftWrapper",
  componentId: "sc-l5ldl0-2"
})(["display:flex;flex-direction:column;"]);
var AddressWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styles__AddressWrapper",
  componentId: "sc-l5ldl0-3"
})(["height:fit-content;display:flex;align-items:center;gap:10px;> span{width:15px !important;height:15px !important;}"]);
var Address = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  displayName: "styles__Address",
  componentId: "sc-l5ldl0-4"
})(["font-size:14px;font-weight:", ";line-height:19px;color:", ";@media ", "{font-size:12px;line-height:17px;}"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.typography.fontWeights.medium;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.blackPallet6;
}, breakpoints/* device.mobile */.U.mobile);
var ButtonLink = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
  displayName: "styles__ButtonLink",
  componentId: "sc-l5ldl0-5"
})(["font-size:14px;font-weight:", ";color:", ";text-align:center;text-decoration-line:underline;background-color:transparent;text-underline-offset:3px;cursor:pointer;&:hover{color:", ";}"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.typography.fontWeights.medium;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.green;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.greenPallet6;
});
var EstimationWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styles__EstimationWrapper",
  componentId: "sc-l5ldl0-6"
})(["display:flex;flex-direction:column;gap:15px;margin-top:30px;@media ", "{margin-top:20px;}"], breakpoints/* device.tablet */.U.tablet);
var EstimationHeading = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  displayName: "styles__EstimationHeading",
  componentId: "sc-l5ldl0-7"
})(["font-size:16px;font-weight:", ";line-height:21px;color:", ";@media ", "{font-size:14px;line-height:19px;}"], function (_ref8) {
  var theme = _ref8.theme;
  return theme.typography.fontWeights.medium;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.colors.grayPallet9;
}, breakpoints/* device.mobile */.U.mobile);
var EstimationPrice = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  displayName: "styles__EstimationPrice",
  componentId: "sc-l5ldl0-8"
})(["font-size:55px;font-weight:", ";color:", ";@media ", "{font-size:32px;}"], function (_ref10) {
  var theme = _ref10.theme;
  return theme.typography.fontWeights.bold;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.colors.greenPallet5;
}, breakpoints/* device.mobile */.U.mobile);
var Divider = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styles__Divider",
  componentId: "sc-l5ldl0-9"
})(["max-width:413px;height:1px;background-color:", ";@media ", "{max-width:265px;}"], function (_ref12) {
  var theme = _ref12.theme;
  return theme.colors.grayPallet18;
}, breakpoints/* device.mobile */.U.mobile);
var EstimationNote = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  displayName: "styles__EstimationNote",
  componentId: "sc-l5ldl0-10"
})(["max-width:471px;font-size:12px;font-weight:", ";line-height:17px;color:", ";@media ", "{font-size:10px;line-height:14px;}"], function (_ref13) {
  var theme = _ref13.theme;
  return theme.typography.fontWeights.regular;
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.colors.grayPallet9;
}, breakpoints/* device.mobile */.U.mobile);
var ChartWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styles__ChartWrapper",
  componentId: "sc-l5ldl0-11"
})(["margin-top:38px;@media ", "{margin-top:25px;&.--desktop{display:none;}&.--tablet{> span{width:100% !important;height:305px !important;}margin-bottom:80px;}}@media ", "{&.--tablet{> span{width:100% !important;height:170px !important;}}}"], breakpoints/* device.tablet */.U.tablet, breakpoints/* device.mobile */.U.mobile);
var Note = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  displayName: "styles__Note",
  componentId: "sc-l5ldl0-12"
})(["max-width:560px;font-size:17px;font-weight:", ";line-height:23px;color:", ";margin:50px 0 20px;@media ", "{margin:30px 0 15px;}@media ", "{font-size:14px;line-height:19px;}"], function (_ref15) {
  var theme = _ref15.theme;
  return theme.typography.fontWeights.semibold;
}, function (_ref16) {
  var theme = _ref16.theme;
  return theme.colors.blackPallet6;
}, breakpoints/* device.tablet */.U.tablet, breakpoints/* device.mobile */.U.mobile);
var ButtonContained = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
  displayName: "styles__ButtonContained",
  componentId: "sc-l5ldl0-13"
})(["width:fit-content;display:flex;align-items:center;font-size:17px;font-weight:", ";color:", ";background-color:", ";text-align:center;padding:17px 34px;cursor:pointer;&:hover{background-color:", ";}&:disabled{background-color:", ";cursor:default;}@media ", "{padding:10px 12px;}"], function (_ref17) {
  var theme = _ref17.theme;
  return theme.typography.fontWeights.medium;
}, function (_ref18) {
  var theme = _ref18.theme;
  return theme.colors.white;
}, function (_ref19) {
  var theme = _ref19.theme;
  return theme.colors.green;
}, function (_ref20) {
  var theme = _ref20.theme;
  return theme.colors.greenPallet6;
}, function (_ref21) {
  var theme = _ref21.theme;
  return theme.colors.grayPallet18;
}, breakpoints/* device.mobile */.U.mobile);
var RightWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styles__RightWrapper",
  componentId: "sc-l5ldl0-14"
})(["display:flex;flex-direction:column;align-items:center;justify-content:center;gap:20px;iframe{width:352px !important;height:543px !important;box-shadow:0px 6px 15px 0px ", "14;}@media ", "{width:100%;#frontchat-repostion-wrapper{width:100%;}iframe{width:100% !important;}}"], function (_ref22) {
  var theme = _ref22.theme;
  return theme.colors.black;
}, breakpoints/* device.tablet */.U.tablet);
var ChatBotNote = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  displayName: "styles__ChatBotNote",
  componentId: "sc-l5ldl0-15"
})(["display:none;font-size:14px;font-weight:", ";line-height:19px;color:", ";@media ", "{display:block;}"], function (_ref23) {
  var theme = _ref23.theme;
  return theme.typography.fontWeights.medium;
}, function (_ref24) {
  var theme = _ref24.theme;
  return theme.colors.greenPallet5;
}, breakpoints/* device.tablet */.U.tablet);
var CMAWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styles__CMAWrapper",
  componentId: "sc-l5ldl0-16"
})(["display:flex;flex-direction:column;width:100%;.cma-toggle-cta{font-size:17px;align-self:center;margin:40px 0 60px;}"]);
var CMAContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styles__CMAContent",
  componentId: "sc-l5ldl0-17"
})(["position:relative;display:flex;flex-direction:column;background-color:", ";padding:136px 0 136px 70px;@media ", "{padding:136px 0 136px 30px;}@media ", "{padding:30px 20px;margin-top:40px;}"], function (_ref25) {
  var theme = _ref25.theme;
  return theme.colors.whitePallet3;
}, breakpoints/* device.laptop */.U.laptop, breakpoints/* device.tablet */.U.tablet);
var ChartHeading = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
  displayName: "styles__ChartHeading",
  componentId: "sc-l5ldl0-18"
})(["font-size:24px;"]);
var AddressErrorTitle = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
  displayName: "styles__AddressErrorTitle",
  componentId: "sc-l5ldl0-19"
})(["font-size:55px;color:", ";margin-top:60px;@media ", "{font-size:32px;margin-top:30px;}"], function (_ref26) {
  var theme = _ref26.theme;
  return theme.colors.blackPallet7;
}, breakpoints/* device.mobile */.U.mobile);
var AddressErrorSubtitle = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
  displayName: "styles__AddressErrorSubtitle",
  componentId: "sc-l5ldl0-20"
})(["max-width:635px;font-size:40px;color:", ";margin-top:30px;@media ", "{font-size:22px;margin-top:15px;}"], function (_ref27) {
  var theme = _ref27.theme;
  return theme.colors.blackPallet7;
}, breakpoints/* device.mobile */.U.mobile);
var AddressErrorDescription = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  displayName: "styles__AddressErrorDescription",
  componentId: "sc-l5ldl0-21"
})(["max-width:586px;font-size:17px;font-weight:", ";line-height:25px;color:", ";margin:30px 0 40px;@media ", "{font-size:14px;margin:20px 0;}"], function (_ref28) {
  var theme = _ref28.theme;
  return theme.typography.fontWeights.medium;
}, function (_ref29) {
  var theme = _ref29.theme;
  return theme.colors.blackPallet7;
}, breakpoints/* device.mobile */.U.mobile);
/* harmony default export */ var valuation_result_styles = ({
  Wrapper: Wrapper,
  ResultWrapper: ResultWrapper,
  LeftWrapper: LeftWrapper,
  AddressWrapper: AddressWrapper,
  Address: Address,
  ButtonLink: ButtonLink,
  EstimationWrapper: EstimationWrapper,
  EstimationHeading: EstimationHeading,
  EstimationPrice: EstimationPrice,
  Divider: Divider,
  EstimationNote: EstimationNote,
  ChartWrapper: ChartWrapper,
  Note: Note,
  ButtonContained: ButtonContained,
  RightWrapper: RightWrapper,
  ChatBotNote: ChatBotNote,
  CMAWrapper: CMAWrapper,
  CMAContent: CMAContent,
  ChartHeading: ChartHeading,
  AddressErrorTitle: AddressErrorTitle,
  AddressErrorSubtitle: AddressErrorSubtitle,
  AddressErrorDescription: AddressErrorDescription
});
;// CONCATENATED MODULE: ./components/home-valuation/cma-section/constants.ts
var media = {
  dots: '/static/images/home-valuation/desktop-dots.svg',
  tick: '/static/images/home-valuation/tick.svg',
  cmaTable: '/static/images/home-valuation/cma-table.webp',
  cmaTableMobile: '/static/images/home-valuation/cma-table-mobile.webp'
};
;// CONCATENATED MODULE: ./components/home-valuation/cma-section/styles.ts


var styles_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styles__Wrapper",
  componentId: "sc-sv7pgx-0"
})(["display:flex;justify-content:space-between;button.button-contained{&:disabled{display:flex;align-items:center;gap:8px;}img.tick-icon{filter:brightness(0) invert(1);margin-left:8px;}}@media ", "{flex-direction:column;}"], breakpoints/* device.tablet */.U.tablet);
var DotsWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styles__DotsWrapper",
  componentId: "sc-sv7pgx-1"
})(["position:absolute;top:25px;left:0;width:216px;height:115px;@media ", "{display:none;}"], breakpoints/* device.tablet */.U.tablet);
var ContentWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styles__ContentWrapper",
  componentId: "sc-sv7pgx-2"
})(["flex:1;display:flex;flex-direction:column;gap:30px;h1{max-width:660px;}p{max-width:560px;font-weight:", ";}@media ", "{gap:25px;p{font-weight:", ";}}"], function (_ref) {
  var theme = _ref.theme;
  return theme.typography.fontWeights.medium;
}, breakpoints/* device.tablet */.U.tablet, function (_ref2) {
  var theme = _ref2.theme;
  return theme.typography.fontWeights.semibold;
});
var EmailInput = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styles__EmailInput",
  componentId: "sc-sv7pgx-3"
})(["display:flex;flex-direction:column;"]);
var InputWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styles__InputWrapper",
  componentId: "sc-sv7pgx-4"
})(["position:relative;max-width:354px;input{padding-right:75px;}@media ", "{max-width:100%;}"], breakpoints/* device.mobile */.U.mobile);
var Input = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
  displayName: "styles__Input",
  componentId: "sc-sv7pgx-5"
})(["height:55px;width:100%;border:1px solid ", ";border-radius:0;background-color:", ";padding:16px 20px;font-weight:", ";color:", ";font-size:17px;line-height:24px;transition:200ms all ease;&.invalid{border:1px solid ", ";}"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.grayPallet20;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.white;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.typography.fontWeights.regular;
}, function (_ref6) {
  var theme = _ref6.theme,
      disabled = _ref6.disabled;
  return disabled ? theme.colors.grayPallet26 : theme.colors.blackPallet6;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.red;
});
var InputCTAWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styles__InputCTAWrapper",
  componentId: "sc-sv7pgx-6"
})(["position:absolute;right:21px;top:50%;transform:translateY(-50%);display:flex;align-items:center;gap:21px;button{width:25px;}"]);
var InputDivider = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styles__InputDivider",
  componentId: "sc-sv7pgx-7"
})(["height:25px;width:1px;background-color:", ";"], function (_ref8) {
  var theme = _ref8.theme;
  return theme.colors.grayPallet19;
});
var ErrorMessage = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  displayName: "styles__ErrorMessage",
  componentId: "sc-sv7pgx-8"
})(["font-size:12px;color:", ";"], function (_ref9) {
  var theme = _ref9.theme;
  return theme.colors.red;
});
var ImageWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styles__ImageWrapper",
  componentId: "sc-sv7pgx-9"
})(["position:relative;width:594px;height:412px;@media ", "{width:450px;height:312px;}@media ", "{width:100%;height:350px;margin-top:25px;}@media ", "{width:100%;height:222px;}"], breakpoints/* device.smallLaptop */.U.smallLaptop, breakpoints/* device.tablet */.U.tablet, breakpoints/* device.mobile */.U.mobile);
/* harmony default export */ var cma_section_styles = ({
  Wrapper: styles_Wrapper,
  DotsWrapper: DotsWrapper,
  ContentWrapper: ContentWrapper,
  EmailInput: EmailInput,
  InputWrapper: InputWrapper,
  Input: Input,
  InputCTAWrapper: InputCTAWrapper,
  InputDivider: InputDivider,
  ErrorMessage: ErrorMessage,
  ImageWrapper: ImageWrapper
});
;// CONCATENATED MODULE: ./components/home-valuation/cma-section/index.tsx



function cma_section_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function cma_section_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? cma_section_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : cma_section_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


















function CMASection(_ref) {
  var _errors$email;

  var homeValuationForm = _ref.homeValuationForm,
      cmaRequested = _ref.cmaRequested,
      onCMARequest = _ref.onCMARequest;
  var errors = homeValuationForm.formState.errors,
      handleSubmit = homeValuationForm.handleSubmit,
      register = homeValuationForm.register,
      watch = homeValuationForm.watch;
  var dispatch = (0,useRedux/* useAppDispatch */.T)();

  var _useAppSelector = (0,useRedux/* useAppSelector */.C)(homeValuationSelector),
      zohoHomeValuation = _useAppSelector.zohoHomeValuation;

  var _useAppSelector2 = (0,useRedux/* useAppSelector */.C)(cmaSelector),
      cma = _useAppSelector2.cma;

  var _useMedia = (0,useMedia/* default */.Z)(),
      isBelowSmallLaptop = _useMedia.isBelowSmallLaptop;

  var _useToggle = (0,useToggle/* default */.Z)(true),
      _useToggle2 = (0,slicedToArray/* default */.Z)(_useToggle, 2),
      isInputDisabled = _useToggle2[0],
      toggleInput = _useToggle2[1];

  var email = watch('email');
  var emailError = errors === null || errors === void 0 ? void 0 : (_errors$email = errors.email) === null || _errors$email === void 0 ? void 0 : _errors$email.message;

  var _ref2 = (zohoHomeValuation === null || zohoHomeValuation === void 0 ? void 0 : zohoHomeValuation.data) || {},
      _ref2$id = _ref2.id,
      leadId = _ref2$id === void 0 ? '' : _ref2$id;

  var isCMAReportSent = (0,lodash.includes)(cmaRequested === null || cmaRequested === void 0 ? void 0 : cmaRequested[leadId], email);
  var isGetCMACTADisabled = !isInputDisabled || isCMAReportSent;

  function onEdit(event) {
    event.preventDefault();
    toggleInput();
  }

  function onSubmit() {
    toggleInput();
  }

  function getCMAReport() {
    if (!(0,lodash.isNil)(leadId)) {
      dispatch((0,cma_thunks/* cmaThunk */.E)({
        leadId: leadId,
        cma_email: email
      }));
    }
  }

  (0,react.useEffect)(function () {
    if (!isInputDisabled) {
      var element = document.querySelector('.email-input');

      if (element) {
        element.focus();
      }
    }
  }, [isInputDisabled]);
  (0,react.useEffect)(function () {
    var _cma$data;

    if ((_cma$data = cma.data) !== null && _cma$data !== void 0 && _cma$data.success && !isCMAReportSent) {
      onCMARequest(leadId, email);
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [cma.data]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(cma_section_styles.Wrapper, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(cma_section_styles.DotsWrapper, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
        src: media.dots,
        alt: "desktop green dots",
        width: 216,
        height: 115,
        layout: "fill"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(cma_section_styles.ContentWrapper, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(typography/* default */.Z, {
        as: "h1",
        fontWeight: "bold",
        variant: "h1",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, cma_section_objectSpread({}, messages.cmaHeading))
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(typography/* default */.Z, {
        as: "p",
        fontWeight: "semibold",
        variant: "bodyMedium",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, cma_section_objectSpread({}, messages.cmaDescription))
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(cma_section_styles.EmailInput, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("form", {
          onSubmit: handleSubmit(onSubmit),
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)(cma_section_styles.InputWrapper, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(cma_section_styles.Input, cma_section_objectSpread({
              className: "email-input",
              type: "email",
              disabled: isInputDisabled
            }, register('email'))), /*#__PURE__*/(0,jsx_runtime.jsxs)(cma_section_styles.InputCTAWrapper, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(cma_section_styles.InputDivider, {}), isInputDisabled ? /*#__PURE__*/(0,jsx_runtime.jsx)(valuation_result_styles.ButtonLink, {
                type: "button",
                onClick: onEdit,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, cma_section_objectSpread({}, messages.editCTA))
              }) : /*#__PURE__*/(0,jsx_runtime.jsx)(valuation_result_styles.ButtonLink, {
                type: "submit",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                  src: media.tick,
                  alt: "tick",
                  width: 24,
                  height: 24
                })
              })]
            })]
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(cma_section_styles.ErrorMessage, {
          children: emailError
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(valuation_result_styles.ButtonContained, {
        className: "button-contained",
        disabled: isGetCMACTADisabled,
        onClick: getCMAReport,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, cma_section_objectSpread({}, isCMAReportSent ? messages.requestSent : messages.cmaCTA)), isCMAReportSent && /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          className: "tick-icon",
          src: media.tick,
          alt: "tick",
          width: 20,
          height: 20
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(cma_section_styles.ImageWrapper, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
        src: isBelowSmallLaptop ? media.cmaTableMobile : media.cmaTable,
        alt: "cma table",
        width: 594,
        height: 412,
        layout: "fill"
      })
    })]
  });
}
;// CONCATENATED MODULE: ./components/home-valuation/valuation-result/constants.ts
var constants_media = {
  location: '/static/images/home-valuation/location.svg',
  locationMobile: '/static/images/home-valuation/location-mobile.svg',
  rightArrow: '/static/images/home-valuation/right-arrow.svg',
  phone: '/static/icons/phone.svg',
  tick: '/static/images/home-valuation/tick.svg'
};
;// CONCATENATED MODULE: ./components/home-valuation/valuation-result/index.tsx



function valuation_result_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function valuation_result_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? valuation_result_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : valuation_result_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






 // import RepositionedFrontChat from 'components/repositioned-frontchat';














function ValuationResult(_ref) {
  var address = _ref.address,
      price = _ref.price,
      chartUrl = _ref.chartUrl,
      onEdit = _ref.onEdit,
      homeValuationForm = _ref.homeValuationForm,
      isWidgetError = _ref.isWidgetError,
      callbackRequested = _ref.callbackRequested,
      cmaRequested = _ref.cmaRequested,
      onCallbackRequest = _ref.onCallbackRequest,
      onCMARequest = _ref.onCMARequest;
  var dispatch = (0,useRedux/* useAppDispatch */.T)();

  var _useAppSelector = (0,useRedux/* useAppSelector */.C)(homeValuationSelector),
      zohoHomeValuation = _useAppSelector.zohoHomeValuation;

  var _useAppSelector2 = (0,useRedux/* useAppSelector */.C)(requestCallbackSelector),
      requestCallbackData = _useAppSelector2.data;

  var _useMedia = (0,useMedia/* default */.Z)(),
      isBelowSmallLaptop = _useMedia.isBelowSmallLaptop;

  var _useToggle = (0,useToggle/* default */.Z)(false),
      _useToggle2 = (0,slicedToArray/* default */.Z)(_useToggle, 2),
      isShowCMA = _useToggle2[0],
      toggleCMA = _useToggle2[1];

  var _ref2 = (zohoHomeValuation === null || zohoHomeValuation === void 0 ? void 0 : zohoHomeValuation.data) || {},
      _ref2$id = _ref2.id,
      leadId = _ref2$id === void 0 ? '' : _ref2$id;

  var isCallbackRequested = (0,lodash.includes)(callbackRequested, leadId);
  var isShowChart = !isWidgetError && !(0,lodash.isEmpty)(chartUrl);
  (0,react.useEffect)(function () {
    (0,utils_scroll/* default */.Z)();
  }, []);
  (0,react.useEffect)(function () {
    if (requestCallbackData !== null && requestCallbackData !== void 0 && requestCallbackData.success && !isCallbackRequested) {
      onCallbackRequest(leadId);
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [requestCallbackData]);

  function onToggleCMA() {
    toggleCMA();

    if (isShowCMA) {
      var element = document.querySelector('.cma-toggle-cta');
      (0,lodash.delay)(function () {
        return element === null || element === void 0 ? void 0 : element.scrollIntoView({
          behavior: 'smooth'
        });
      }, 100);
    }
  }

  function getCallback() {
    if (!(0,lodash.isNil)(leadId)) {
      dispatch((0,slice_thunks/* requestCallbackThunk */.f)({
        leadId: leadId
      }));
    }
  }

  function renderContent() {
    if (isWidgetError) {
      return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(valuation_result_styles.AddressErrorTitle, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, valuation_result_objectSpread({}, messages.addressErrorTitle))
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(valuation_result_styles.AddressErrorSubtitle, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, valuation_result_objectSpread({}, messages.addressErrorSubtitle))
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(valuation_result_styles.AddressErrorDescription, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, valuation_result_objectSpread({}, messages.addressErrorDescription))
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(valuation_result_styles.ButtonContained, {
          className: "get-callback-cta",
          disabled: isCallbackRequested,
          onClick: getCallback,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, valuation_result_objectSpread({}, isCallbackRequested ? messages.requestSent : messages.addressErrorCTA)), isCallbackRequested ? /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
            className: "tick-icon",
            src: constants_media.tick,
            alt: "tick",
            width: 20,
            height: 20
          }) : /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
            src: constants_media.phone,
            alt: "phone",
            width: 20,
            height: 20
          })]
        })]
      });
    }

    return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(valuation_result_styles.EstimationWrapper, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(valuation_result_styles.EstimationHeading, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, valuation_result_objectSpread({}, messages.estimationHeading))
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(valuation_result_styles.EstimationPrice, {
          children: price
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(valuation_result_styles.Divider, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(valuation_result_styles.EstimationNote, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, valuation_result_objectSpread({}, messages.estimationNote))
        })]
      }), isShowChart && /*#__PURE__*/(0,jsx_runtime.jsx)(valuation_result_styles.ChartWrapper, {
        className: "--desktop",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          src: chartUrl,
          alt: "Chart",
          width: 326,
          height: 140
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(valuation_result_styles.Note, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, valuation_result_objectSpread({}, messages.tenXNote))
      }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
        href: "/listing",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(valuation_result_styles.ButtonContained, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, valuation_result_objectSpread({}, messages.startListingCTA)), /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
            src: constants_media.rightArrow,
            alt: "Right Arrow",
            width: 20,
            height: 20
          })]
        })
      })]
    });
  }

  function renderCMAContent() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(CMASection, {
      homeValuationForm: homeValuationForm,
      cmaRequested: cmaRequested,
      onCMARequest: onCMARequest
    });
  }

  function renderCMA() {
    if (isBelowSmallLaptop) {
      return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [isShowCMA && /*#__PURE__*/(0,jsx_runtime.jsxs)(valuation_result_styles.CMAContent, {
          children: [isShowChart && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(valuation_result_styles.ChartHeading, {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, valuation_result_objectSpread({}, messages.chartHeading))
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(valuation_result_styles.ChartWrapper, {
              className: "--tablet",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                src: chartUrl,
                alt: "Chart",
                width: 326,
                height: 140
              })
            })]
          }), renderCMAContent()]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(valuation_result_styles.ButtonLink, {
          className: "cma-toggle-cta",
          onClick: onToggleCMA,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, valuation_result_objectSpread({}, isShowCMA ? messages.showLessCTA : messages.showMoreCTA))
        })]
      });
    }

    return /*#__PURE__*/(0,jsx_runtime.jsx)(valuation_result_styles.CMAContent, {
      children: renderCMAContent()
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(valuation_result_styles.Wrapper, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(valuation_result_styles.ResultWrapper, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(valuation_result_styles.LeftWrapper, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(valuation_result_styles.AddressWrapper, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
            src: isBelowSmallLaptop ? constants_media.locationMobile : constants_media.location,
            alt: "Location",
            width: 20,
            height: 20
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(valuation_result_styles.Address, {
            children: address
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(valuation_result_styles.ButtonLink, {
            onClick: onEdit,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, valuation_result_objectSpread({}, messages.editCTA))
          })]
        }), renderContent()]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(valuation_result_styles.RightWrapper, {
        children: !isWidgetError && /*#__PURE__*/(0,jsx_runtime.jsx)(valuation_result_styles.ChatBotNote, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, valuation_result_objectSpread({}, messages.chatBotNote))
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(valuation_result_styles.CMAWrapper, {
      children: renderCMA()
    })]
  });
}
;// CONCATENATED MODULE: ./components/home-valuation/index.tsx



function home_valuation_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function home_valuation_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? home_valuation_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : home_valuation_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


























var defaultValues = {
  first_name: '',
  last_name: '',
  address: '',
  email: '',
  phone_number: ''
};

function HomeValuation() {
  var _useMedia = (0,useMedia/* default */.Z)(),
      isBelowSmallLaptop = _useMedia.isBelowSmallLaptop;

  var _useTriggerFunnelytic = (0,useTriggerFunnelyticsEvent/* default */.Z)(),
      triggerEvent = _useTriggerFunnelytic.triggerEvent;

  var _useState = (0,react.useState)(false),
      widgetError = _useState[0],
      setWidgetError = _useState[1];

  var _useState2 = (0,react.useState)(null),
      price = _useState2[0],
      setPrice = _useState2[1];

  var _useState3 = (0,react.useState)(''),
      chartUrl = _useState3[0],
      setChartUrl = _useState3[1];

  var _useState4 = (0,react.useState)(false),
      loading = _useState4[0],
      setLoading = _useState4[1];

  var _useState5 = (0,react.useState)(false),
      hasWidgetLoaded = _useState5[0],
      setHasWidgetLoaded = _useState5[1];

  var _useState6 = (0,react.useState)(''),
      widgetHTML = _useState6[0],
      setWidgetHTML = _useState6[1];

  var _useState7 = (0,react.useState)({}),
      googleData = _useState7[0],
      setGoogleData = _useState7[1];

  var widgetRef = (0,react.useRef)();
  var dispatch = (0,es/* useDispatch */.I0)();

  var _useState8 = (0,react.useState)([]),
      callbackRequested = _useState8[0],
      setCallbackRequested = _useState8[1];

  var _useState9 = (0,react.useState)({}),
      cmaRequested = _useState9[0],
      setCMARequested = _useState9[1];

  var homeValuationForm = (0,index_esm/* useForm */.cI)({
    mode: 'onTouched',
    resolver: (0,yup/* yupResolver */.X)(validations/* homeValuationSchema */.iK),
    defaultValues: defaultValues
  });
  var isSectionOne = !hasWidgetLoaded && !widgetError;
  var isSectionTwo = hasWidgetLoaded || widgetError;
  var isMobileStepOne = isBelowSmallLaptop && (0,lodash.isEmpty)(googleData === null || googleData === void 0 ? void 0 : googleData.state);
  var isMobileStepTwo = isBelowSmallLaptop && !(0,lodash.isEmpty)(googleData === null || googleData === void 0 ? void 0 : googleData.state);
  (0,react.useEffect)(function () {
    window.sessionStorage.setItem('resetUtmParams', 'true');
  }, []);
  (0,react.useEffect)(function () {
    if (hasWidgetLoaded) {
      processResults();
    } else {
      setPrice(null);
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [hasWidgetLoaded]);

  function onCallbackRequest(newLeadId) {
    setCallbackRequested(function (prevState) {
      return [].concat((0,toConsumableArray/* default */.Z)(prevState), [newLeadId]);
    });
  }

  function onCMARequest(newLeadId, newEmail) {
    setCMARequested(function (prevState) {
      return home_valuation_objectSpread(home_valuation_objectSpread({}, prevState), {}, (0,defineProperty/* default */.Z)({}, newLeadId, [].concat((0,toConsumableArray/* default */.Z)((0,lodash.has)(prevState, newLeadId) ? prevState[newLeadId] : []), [newEmail])));
    });
  }

  function sendLeads(homePrice) {
    var getValues = homeValuationForm.getValues;
    var formData = getValues();
    var eventName = constants/* HOME_VALUATION_EVENTS */.eM[(0,lodash.startsWith)(homePrice, 'rprError') ? 'SUBMIT_WITHOUT_AVM_DATA' : 'SUBMIT'];
    triggerEvent({
      eventName: eventName,
      data: {
        name: "".concat(formData.first_name, " ").concat(formData.last_name),
        address: formData.address,
        phone_number: formData.phone_number,
        email: formData.email
      }
    });
    var street1 = googleData.street1,
        city = googleData.city,
        state = googleData.state,
        zip = googleData.zip;
    dispatch((0,thunks/* zohoHomeValuationThunk */.w)(home_valuation_objectSpread(home_valuation_objectSpread({}, formData), {}, {
      street: street1,
      city: city,
      state: state,
      zip_code: zip,
      home_price: homePrice,
      country: 'US'
    })));
  }

  function processResults() {
    var _doc$querySelector;

    var parser = new DOMParser();
    var doc = parser.parseFromString(widgetHTML, 'text/html');
    var finalPrice = doc.querySelector('.rprw-est-value');
    var chartImageUrl = (_doc$querySelector = doc.querySelector('.rprw-chart-cont img')) === null || _doc$querySelector === void 0 ? void 0 : _doc$querySelector.src;

    if (!(0,lodash.isNil)(finalPrice) && finalPrice.hasChildNodes()) {
      var priceDiv = finalPrice.childNodes[0];
      var priceText = priceDiv.textContent;

      if (priceText) {
        setPrice(priceText);
        sendLeads(priceText.replace(/,/g, '').slice(1));
      }
    }

    if (!(0,lodash.isNil)(chartImageUrl)) {
      setChartUrl(chartImageUrl);
    }
  }

  function onSubmit(data) {
    var address = data.address;
    setLoading(true);
    setWidgetError(false);
    setHasWidgetLoaded(false);
    setWidgetHTML('');
    setPrice(null);
    var rprUrlParams = new URLSearchParams({
      Token: home_valuation_constants/* RPR_TOKEN */.FG,
      Query: address,
      cbcode: home_valuation_constants/* RPR_CBCODE */.uW,
      ShowRprLinks: 'false'
    });
    fetch_jsonp_default()("".concat(home_valuation_constants/* RPR_WIDGET_URL */.tn, "?").concat(rprUrlParams.toString())).then(function (res) {
      return res.json();
    }).then(function (jsonResult) {
      if ((0,lodash.isEqual)(jsonResult.status, 0)) {
        setHasWidgetLoaded(true);
        setWidgetHTML(jsonResult.html);
      } else {
        setWidgetError(true);
        sendLeads("rprError: ".concat(jsonResult.statusText));
      }
    })["catch"](function () {
      setWidgetError(true);
      sendLeads('rprError');
    })["finally"](function () {
      return setLoading(false);
    });
  }

  function scrollToWidget() {
    var _widgetRef$current;

    widgetRef === null || widgetRef === void 0 ? void 0 : (_widgetRef$current = widgetRef.current) === null || _widgetRef$current === void 0 ? void 0 : _widgetRef$current.scrollIntoView({
      behavior: 'smooth'
    });
  }

  function getHeaderText() {
    if (isBelowSmallLaptop) {
      if (isMobileStepOne) {
        return messages.headerOneForMobile;
      }

      return messages.headerTwoForMobile;
    }

    return messages.header;
  }

  function resetAddress() {
    var getValues = homeValuationForm.getValues;
    var address = getValues('address');
    setGoogleData({
      full: address
    });
    setHasWidgetLoaded(false);
    setWidgetError(false);
    (0,lodash.delay)(function () {
      var _document$querySelect;

      (_document$querySelect = document.querySelector('.autocomplete-input')) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.focus();
    }, 100);
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(styles.ValuationWrapper, {
    isSectionTwo: isSectionTwo,
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("title", {
        children: "Free Home Valuation"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "description",
        content: "Get a free estimate of your home's value with Richr's home valuation tool. Our proprietary algorithm analyzes data from recent home sales in your area to provide you with an accurate valuation."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("script", {
        type: "application/ld+json" // eslint-disable-next-line react/no-danger
        ,
        dangerouslySetInnerHTML: {
          __html: JSON.stringify(home_valuation_constants/* schemaJson */.m3)
        }
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(homepage_header/* default */.Z, {
      isWhiteLinks: isSectionOne
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(styles.Heading, {
      hidden: isSectionTwo,
      isMobileStepTwo: isMobileStepTwo,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, home_valuation_objectSpread(home_valuation_objectSpread({}, getHeaderText()), {}, {
        values: {
          rsquo: /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: "\u2019"
          })
        }
      }))
    }), isBelowSmallLaptop && !isMobileStepTwo && !hasWidgetLoaded && /*#__PURE__*/(0,jsx_runtime.jsx)(ValuationFormMobile, {
      setGoogleData: setGoogleData,
      homeValuationForm: homeValuationForm
    }), isSectionTwo && /*#__PURE__*/(0,jsx_runtime.jsx)(ValuationResult, {
      address: googleData === null || googleData === void 0 ? void 0 : googleData.full,
      price: price,
      chartUrl: chartUrl,
      onEdit: resetAddress,
      homeValuationForm: homeValuationForm,
      isWidgetError: widgetError,
      callbackRequested: callbackRequested,
      onCallbackRequest: onCallbackRequest,
      cmaRequested: cmaRequested,
      onCMARequest: onCMARequest
    }), isSectionOne && /*#__PURE__*/(0,jsx_runtime.jsxs)(styles.FormAndWidgetWrapper, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(styles.FormWrapper, {
        hidden: isMobileStepOne,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(valuation_form, {
          onSubmit: onSubmit,
          widgetError: widgetError,
          price: price,
          loading: loading,
          setGoogleData: setGoogleData,
          scrollToWidget: scrollToWidget,
          hasWidgetLoaded: hasWidgetLoaded,
          homeValuationForm: homeValuationForm,
          address: googleData === null || googleData === void 0 ? void 0 : googleData.full,
          onBack: resetAddress
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        hidden: isMobileStepTwo,
        children: hasWidgetLoaded ? /*#__PURE__*/(0,jsx_runtime.jsx)(styles.WidgetSection, {
          id: "widgetWrapper",
          hasWidgetLoaded: hasWidgetLoaded,
          dangerouslySetInnerHTML: {
            __html: widgetHTML
          },
          ref: widgetRef
        }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(styles.WidgetSection, {
          id: "widgetWrapper",
          hasWidgetLoaded: hasWidgetLoaded,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(styles.WidgetOverlayImage, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
              src: home_valuation_constants/* media.lockIcon */.BC.lockIcon,
              width: 31,
              height: 31,
              alt: ""
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
            src: home_valuation_constants/* media.reportBlur */.BC.reportBlur,
            width: 350,
            height: "100%",
            alt: "report-preview"
          })]
        })
      })]
    }), isSectionTwo && /*#__PURE__*/(0,jsx_runtime.jsx)(homepage_footer/* default */.Z, {})]
  });
}

/* harmony default export */ var home_valuation = (HomeValuation);
;// CONCATENATED MODULE: ./components/layout/valuation-layout/styles.ts

var ValuationLayoutWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styles__ValuationLayoutWrapper",
  componentId: "sc-1idx2l8-0"
})(["display:flex;flex-direction:column;min-height:100vh;.valuation-main{flex:auto;}"]);
;// CONCATENATED MODULE: ./components/layout/valuation-layout/index.tsx



function ValuationLayout(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(ValuationLayoutWrapper, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("main", {
      className: "valuation-main",
      children: children
    })
  });
}

/* harmony default export */ var valuation_layout = (ValuationLayout);
;// CONCATENATED MODULE: ./containers/free-home-valuation/index.tsx



function FreeHomeValuation() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(valuation_layout, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(home_valuation, {})
  });
}
;// CONCATENATED MODULE: ./pages/free-home-valuation/index.tsx



function FreeHomeValuationPage() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(FreeHomeValuation, {});
}

/* harmony default export */ var free_home_valuation = (FreeHomeValuationPage);

/***/ }),

/***/ 82142:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ scrollToTop; }
/* harmony export */ });
function scrollToTop() {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  });
}

/***/ }),

/***/ 89892:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/free-home-valuation",
      function () {
        return __webpack_require__(79853);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(72717)


/***/ }),

/***/ 76362:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S1": function() { return /* binding */ off; },
/* harmony export */   "jU": function() { return /* binding */ isBrowser; },
/* harmony export */   "on": function() { return /* binding */ on; }
/* harmony export */ });
/* unused harmony exports noop, isNavigator */
var noop = function () { };
function on(obj) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    if (obj && obj.addEventListener) {
        obj.addEventListener.apply(obj, args);
    }
}
function off(obj) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    if (obj && obj.removeEventListener) {
        obj.removeEventListener.apply(obj, args);
    }
}
var isBrowser = typeof window !== 'undefined';
var isNavigator = typeof navigator !== 'undefined';


/***/ }),

/***/ 45101:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm_useRafState; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/react-use/esm/useEffectOnce.js

var useEffectOnce = function (effect) {
    (0,react.useEffect)(effect, []);
};
/* harmony default export */ var esm_useEffectOnce = (useEffectOnce);

;// CONCATENATED MODULE: ./node_modules/react-use/esm/useUnmount.js


var useUnmount = function (fn) {
    var fnRef = (0,react.useRef)(fn);
    // update the ref each render so if it change the newest callback will be invoked
    fnRef.current = fn;
    esm_useEffectOnce(function () { return function () { return fnRef.current(); }; });
};
/* harmony default export */ var esm_useUnmount = (useUnmount);

;// CONCATENATED MODULE: ./node_modules/react-use/esm/useRafState.js


var useRafState = function (initialState) {
    var frame = (0,react.useRef)(0);
    var _a = (0,react.useState)(initialState), state = _a[0], setState = _a[1];
    var setRafState = (0,react.useCallback)(function (value) {
        cancelAnimationFrame(frame.current);
        frame.current = requestAnimationFrame(function () {
            setState(value);
        });
    }, []);
    esm_useUnmount(function () {
        cancelAnimationFrame(frame.current);
    });
    return [state, setRafState];
};
/* harmony default export */ var esm_useRafState = (useRafState);


/***/ }),

/***/ 89211:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var toggleReducer = function (state, nextValue) {
    return typeof nextValue === 'boolean' ? nextValue : !state;
};
var useToggle = function (initialValue) {
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useReducer)(toggleReducer, initialValue);
};
/* harmony default export */ __webpack_exports__["Z"] = (useToggle);


/***/ }),

/***/ 98504:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _useRafState__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45101);
/* harmony import */ var _misc_util__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(76362);



var useWindowSize = function (initialWidth, initialHeight) {
    if (initialWidth === void 0) { initialWidth = Infinity; }
    if (initialHeight === void 0) { initialHeight = Infinity; }
    var _a = (0,_useRafState__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
        width: _misc_util__WEBPACK_IMPORTED_MODULE_2__/* .isBrowser */ .jU ? window.innerWidth : initialWidth,
        height: _misc_util__WEBPACK_IMPORTED_MODULE_2__/* .isBrowser */ .jU ? window.innerHeight : initialHeight,
    }), state = _a[0], setState = _a[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        if (_misc_util__WEBPACK_IMPORTED_MODULE_2__/* .isBrowser */ .jU) {
            var handler_1 = function () {
                setState({
                    width: window.innerWidth,
                    height: window.innerHeight,
                });
            };
            (0,_misc_util__WEBPACK_IMPORTED_MODULE_2__.on)(window, 'resize', handler_1);
            return function () {
                (0,_misc_util__WEBPACK_IMPORTED_MODULE_2__/* .off */ .S1)(window, 'resize', handler_1);
            };
        }
    }, []);
    return state;
};
/* harmony default export */ __webpack_exports__["Z"] = (useWindowSize);


/***/ }),

/***/ 16835:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _slicedToArray; }
});

;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/arrayWithHoles.js
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/iterableToArrayLimit.js
function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
var unsupportedIterableToArray = __webpack_require__(2937);
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/nonIterableRest.js
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js




function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || (0,unsupportedIterableToArray/* default */.Z)(arr, i) || _nonIterableRest();
}

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5675,4588,7536,9491,8837,7333,7398,8664,9774,2888,179], function() { return __webpack_exec__(89892); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);